import React, { Component } from "react";
import { get } from 'lodash';
import { Grid } from '@material-ui/core';
import { Formik } from "formik";
import { FormikInputCheckbox, FormikInputText, FormikInputPercent, ButtonIcon, PrimaryButton, ButtonSizeOptions, SecondaryButton, FormikInputRadioField, INPUT_RADIO_FIELD_TYPES } from '@loanbossinc/component-library';
import styled from "styled-components";

const StyledTitleSection = styled.div`
  && {
    padding-top: 33px;
    padding-bottom: 33px;
    padding-right: 16px;
    height: 86px;
    width: 705px;
    background: #FFFFFF;
    /* Stroke / Gray */
    border: 1px solid #DADCE0;
    box-sizing: border-box;
    /* Card shadow */
    box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
    .title {
      font-family: Work Sans;
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 28px;
      display: flex;
      align-items: center;
      text-align: center;
  
      color: #000000;
    }
    .material-icons {
        color: #C40A0A
    }
  }
`;
const StyledButtonIcon = styled(ButtonIcon)`{
     color: #C40A0A;
 }`;

const StyledGridItem = styled(Grid)`{
     display: flex;
 }`;

const StyledButtonWrapper = styled.div`{
    float: right;
 }`;

const StyledSubSection = styled.div`{
    margin-left: 30px;
    padding: 26px;
    width: 648px;

    background: #FFFFFF;
    /* Stroke / Gray */

    border: 1px solid #DADCE0;
    box-sizing: border-box;
    
    .topSection {
        margin-top: 28px;
    }

    .title {
        height: 14px;      
        font-family: Work Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;       
        display: flex;
        align-items: flex-end;
        text-transform: uppercase;
        color: #5F6368;
    }
 }`;
const StyledRemoveButton = styled.div`{
    cursor: pointer;
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    margin-top: 30px;
    align-items: center;
    color: #005AA9;
 }`;
export default class RecourseSchedule extends Component {
    state= { hasRecourseAmountChanged: false}
    constructor(props) {
        super(props);
        this.formik = React.createRef();
    }

    setCurrent(values) {
        const { handleCurrent } = this.props;
        values.isCurrent = true;
        handleCurrent(values.id);
    }

    addCondition(values) {
        if (!this.formik.current) return null;
        const customCondition = {
            isComplete: false,
            condition: ""
        }
        let customConditions = values;
        customConditions.guarantorRecourseScheduleCustomConditions.push(customCondition);
        this.formik.current.setValues({ ...values, customConditions });
    }
    addCovenants(values) {
        if (!this.formik.current) return null;
        let customConditions = values;
        customConditions.hasAddedCovenants = !customConditions.hasAddedCovenants;
        this.formik.current.setValues({ ...values, customConditions });
    }
    removeCondition(values, index) {
        if (!this.formik.current) return null;

        let customConditions = values;
        if (index > -1) {
            customConditions.guarantorRecourseScheduleCustomConditions.splice(index, 1);
        }

        this.formik.current.setValues({ ...values, customConditions });
    }
    markComplete(values, index) {
        let customConditions = values;
        let condition = customConditions.guarantorRecourseScheduleCustomConditions[index];
        condition.isComplete = !condition.isComplete;
        this.formik.current.setValues({ ...values, customConditions });
    }
    isDisabled(values, field) {
        if (!values) return true;
        return !get(values, field);
    }
    handleReset(initialValues, formik) {
        formik.resetForm(initialValues);
    }

    renderHeader(handleSubmit, values) {
        const { onClose } = this.props;
        return (<StyledTitleSection>
            <Grid container>
                <StyledGridItem item xs={6}>
                    <StyledButtonIcon style={{ width: '80px' }} iconName="close" onClick={onClose} />
                    <span className="title">Add Burndown</span>
                </StyledGridItem>
                <Grid item xs={6}>
                    <StyledButtonWrapper>
                        <SecondaryButton
                            style={{ marginLeft: 'auto' }}
                            label="Set as current"
                            onClick={() => this.setCurrent(values, handleSubmit)}
                            size={ButtonSizeOptions.smFluid}
                        />
                        <PrimaryButton
                            style={{ marginLeft: 24 }}
                            label="Save"
                            onClick={handleSubmit}
                            size={ButtonSizeOptions.smFluid}
                        />
                    </StyledButtonWrapper>
                </Grid>
            </Grid>
        </StyledTitleSection>);

    }
    renderRecourseAmount(values, initialItem) {
        const recourseAmountRadio = { name: `recourseAmountRadio`, fieldName: `recourseAmount`, handleChange: (formik, fieldName, value) => { formik.setFieldValue(fieldName, value); }, label: `Fixed Amount ($)`, decimals: 2, inputFormatt: INPUT_RADIO_FIELD_TYPES.DOLLAR, isVisible: false };
        const recoursePercentRadio = { name: `recoursePercentRadio`, fieldName: `recoursePercent`, handleChange: (formik, fieldName, value) => { formik.setFieldValue(fieldName, value); }, label: "% of Loan Balance", decimals: 2, inputFormatt: INPUT_RADIO_FIELD_TYPES.PERCENT };
        const radioButtons = [];

        if(values.sortOrder === 0){
            radioButtons.push(recourseAmountRadio);
            radioButtons.push(recoursePercentRadio);
        } else {
            initialItem.recourseType === `recourseAmountRadio` ? radioButtons.push(recourseAmountRadio) : radioButtons.push(recoursePercentRadio);
        }

        return (<StyledSubSection style={{ marginTop: '28px' }} >
            <div className="title">Recourse amount</div>
            <FormikInputRadioField
                handleRadioButtonChange={(formik, radioButtons, value) => {
                    formik.setFieldValue("recourseType", value);
                    this.setState({hasRecourseAmountChanged: true});
                }}
                radioValue={"recourseType"}
                radioButtons={radioButtons}
                formik={this.formik}
                data
            />
        </StyledSubSection>);
    }
    renderChosenCovenants(values) {
        const hasAddedCovenants = get(values, 'hasAddedCovenants');

        if (!hasAddedCovenants)
            return (<StyledSubSection >
                <Grid container>
                    <Grid item xs={6}><div className="title">Chosen covenants</div></Grid>
                    <Grid item xs={6}><PrimaryButton
                        style={{ float: 'right' }}
                        label="Add Covenants"
                        onClick={() => this.addCovenants(values)}
                        size={ButtonSizeOptions.smFluid}
                    /></Grid>
                </Grid>
            </StyledSubSection>);


        const dscrDisabled = this.isDisabled(values, "hasDSCRCondition");
        const ltvDisabled = this.isDisabled(values, "hasLTVCondition");
        const debtYieldDisabled = this.isDisabled(values, "hasDebtYieldCondition");
        const occupancyDisabled = this.isDisabled(values, "hasOccupancyCondition");

        return (<StyledSubSection >
            <div className="title">Chosen covenants</div>
            <Grid container>
                <Grid container item xs={12}>
                    <Grid item xs={6}>
                        <FormikInputCheckbox name={"hasDSCRCondition"} label={"DSCR"} />
                    </Grid>
                    <Grid item xs={6}>
                        <FormikInputPercent name={"dscr"} variant={"filled"} decimals={2} disabled={dscrDisabled} />
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={6}>
                        <FormikInputCheckbox name={"hasLTVCondition"} label={"LTV"} />
                    </Grid>
                    <Grid item xs={6}>
                        <FormikInputPercent name={"ltv"} variant={"filled"} decimals={2} disabled={ltvDisabled} />
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={6}>
                        <FormikInputCheckbox name={"hasDebtYieldCondition"} label={"Debt Yield"} />
                    </Grid>
                    <Grid item xs={6}>
                        <FormikInputPercent name={"debtYield"} variant={"filled"} decimals={2} disabled={debtYieldDisabled} />
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={6}>
                        <FormikInputCheckbox name={"hasOccupancyCondition"} label={"Occupancy"} />
                    </Grid>
                    <Grid item xs={6}>
                        <FormikInputPercent name={"occupancy"} variant={"filled"} decimals={2} disabled={occupancyDisabled} />
                    </Grid>

                </Grid>
            </Grid>
        </StyledSubSection>);
    }
    renderNewCustomCondition(values) {
        const { onClose, onSave, data } = this.props;
        const dscrDisabled = this.isDisabled("hasDSCRCondition");
        const ltvDisabled = this.isDisabled("hasLTVCondition");
        const debtYieldDisabled = this.isDisabled("hasDebtYieldCondition");
        const occupancyDisabled = this.isDisabled("hasOccupancyCondition");
        return (<StyledSubSection >
            <Grid container>
                <Grid item xs={6}><div className="title">Create new custom condition</div></Grid>
                <Grid item xs={6}><PrimaryButton
                    style={{ float: 'right' }}
                    label="Add condition"
                    onClick={() => this.addCondition(values)}
                    size={ButtonSizeOptions.smFluid}
                /></Grid>
            </Grid>
        </StyledSubSection>);
    }
    renderCustomConditions(values) {
        if (!this.formik.current) return null;
        let currentValues = this.formik.current.state.values;
        return currentValues.guarantorRecourseScheduleCustomConditions.map((x, index) => {
            return (<StyledSubSection style={{ marginTop: '28px' }} >
                <div className="title">Custom condition-{index}</div>

                <Grid container>
                    <Grid container item xs={12}>
                        <Grid item xs={6}>
                            <FormikInputText
                                label="Custom condition name"
                                name={`guarantorRecourseScheduleCustomConditions[${index}].condition`}
                                variant={"filled"} />
                        </Grid>
                        <Grid item xs={6}>
                            <PrimaryButton
                                style={{ float: 'right' }}
                                label={`Mark as ${x.isComplete ? `incomplete` : `complete`}`}
                                onClick={() => this.markComplete(values, index)}
                                size={ButtonSizeOptions.smFluid}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <StyledRemoveButton onClick={() => this.removeCondition(values, index)}>Remove condition field</StyledRemoveButton>
                        </Grid>
                    </Grid>
                </Grid>

            </StyledSubSection>)
        })
    }


    render() {
        const { onSave, data, initialItem, recourseAmountChange } = this.props;
        return (
            <div style={{ background: '#F5F3F3', height: '100%' }} className="ryan">
                <Formik
                    ref={this.formik}
                    enableReinitialize
                    initialValues={data}
                    validateOnChange={true}
                    validate={values => {
                        let errors = {}
                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        onSave(values);
                        setSubmitting(false);
                        
                        if(values.sortOrder === 0 && this.state.hasRecourseAmountChanged){
                            recourseAmountChange(values);
                            this.setState({hasRecourseAmountChanged: false});
                        }
                    }}
                    onReset={this.handleReset}
                    render={({ values, errors, status, touched, isSubmitting, handleChange, handleBlur, handleSubmit }) => {
                        return (
                            <>
                                {this.renderHeader(handleSubmit, values)}
                                {this.renderRecourseAmount(values, initialItem)}
                                {this.renderChosenCovenants(values)}
                                {this.renderNewCustomCondition(values)}
                                {this.renderCustomConditions(values)}
                            </>
                        )
                    }}
                />
            </div>
        );
    }
}

